import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import OpenFundSection from '../components/OpenFundSection';
import SupportedFields from '../components/SupportedFields';
import ToggleSwitch from '../../../components/ui/ToggleSwitch/ToggleSwitch';
import { useOpenFundFieldTracking } from '../OpenFundAnalyticsContext';
import { WelfareFormData } from '../schemas/openFundFormSchema';
import styles from './steps.module.scss';

const SupportedsStep = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<WelfareFormData>();
  const trackField = useOpenFundFieldTracking();

  return (
    <div className={styles.stepWrapper}>
      <OpenFundSection title={t('openFundRequest.steps.supporteds')}>
        <SupportedFields />
        <div className={styles.toggleGroup}>
          <Controller
            control={control}
            name="supportedAwareOfFund"
            render={({ field }) => (
              <ToggleSwitch
                label={t('openFundRequest.fields.supportedAwareOfFund')}
                checked={field.value}
                onChange={(value) => {
                  field.onChange(value);
                  trackField('supportedAwareOfFund');
                }}
              />
            )}
          />
          <Controller
            control={control}
            name="supportedCanViewFund"
            render={({ field }) => (
              <ToggleSwitch
                label={t('openFundRequest.fields.supportedCanViewFund')}
                checked={field.value}
                onChange={(value) => {
                  field.onChange(value);
                  trackField('supportedCanViewFund');
                }}
              />
            )}
          />
        </div>
      </OpenFundSection>
    </div>
  );
};

export default SupportedsStep;
